import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import Header from "./components/Header";
import Routes from "./components/Routes";
import { isDevelopment } from "./const";
import Main from "./pages/Main";
import { CookieBanner } from "components/CookieBanner";

function App() {
  return (
    <div className="app">
      <Header />
      {!isDevelopment ? (
        <>
          <AuthenticatedTemplate>
            <Routes />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Main />
          </UnauthenticatedTemplate>
        </>
      ) : (
        <Routes />
      )}
      <CookieBanner />
    </div>
  );
}

export default App;
